import { createSelector } from 'reselect';
import { shareAllergiesSendingSelector } from 'store/medicalHistory/allergies/selectors';
import {
  shareImmunizationsSendingSelector,
  shareUsirSendingSelector
} from 'store/medicalHistory/immunizations/selectors';
import { shareProblemsSendingSelector } from 'store/medicalHistory/problems/selectors';
import { shareProceduresSendingSelector } from 'store/medicalHistory/procedures/selectors';
import { shareSocialHistorySendingSelector } from 'store/medicalHistory/socialHistory/selectors';
import { shareMedicalHistorySendingSelector } from 'store/medicalHistory/selectors';
import {
  visitSummaryShareCcdSendingSelector,
  visitSummaryMultipleShareCcdSendingSelector
} from 'store/visitSummary/selectors';
import { shareVitalsSendingSelector } from 'store/vitals/selectors';
import {
  shareLabResultsSendingSelector,
  shareMicrobiologyResultsSendingSelector,
  shareImagingResultsSendingSelector,
  sharePathologyResultsSendingSelector
} from 'store/testResults/selectors';
import { shareMedicationsSendingSelector } from 'store/medications/selectors';
import { shareHealthRecordSummarySendingSelector } from 'store/healthRecords/selectors';
import { shareClinicNotesSelector } from 'store/clinicNotes/selectors';

export const transmitSendingSelector = createSelector(
  [
    visitSummaryShareCcdSendingSelector,
    visitSummaryMultipleShareCcdSendingSelector,
    shareVitalsSendingSelector,
    shareMedicationsSendingSelector,
    shareAllergiesSendingSelector,
    shareImmunizationsSendingSelector,
    shareUsirSendingSelector,
    shareProblemsSendingSelector,
    shareProceduresSendingSelector,
    shareSocialHistorySendingSelector,
    shareMedicalHistorySendingSelector,
    shareLabResultsSendingSelector,
    shareMicrobiologyResultsSendingSelector,
    shareImagingResultsSendingSelector,
    sharePathologyResultsSendingSelector,
    shareHealthRecordSummarySendingSelector,
    shareClinicNotesSelector
  ],
  (
    sharingVisitSummaryCcd,
    sharingMultipleVisitSummaryCcd,
    sharingMedications,
    sharingVitals,
    sharingAllergies,
    sharingImmunizations,
    sharingUsir,
    sharingProblems,
    sharingProcedures,
    sharingSocialHistory,
    sharingMedicalHistory,
    sharingLabResults,
    sharingMicrobiologyResults,
    sharingImagingResults,
    sharingPathologyResults,
    sharingHealthRecordSummary,
    sharingClinicNotes
  ) => {
    return (
      sharingVisitSummaryCcd ||
      sharingMultipleVisitSummaryCcd ||
      sharingMedications ||
      sharingVitals ||
      sharingAllergies ||
      sharingImmunizations ||
      sharingUsir ||
      sharingProblems ||
      sharingProcedures ||
      sharingSocialHistory ||
      sharingMedicalHistory ||
      sharingLabResults ||
      sharingMicrobiologyResults ||
      sharingImagingResults ||
      sharingPathologyResults ||
      sharingHealthRecordSummary ||
      sharingClinicNotes
    );
  }
);
